import React from 'react';
import { useUser } from '@sde/widgets-core/src/redux/resources/user';
import { IdleUser } from '@sde/widgets-core/src/widgets/IdleUser';
import { handleLogout } from '@src/tools/handleLogout';

export const IdleUserWidget = () => {
  const { user } = useUser.state();
  const { validateUser } = useUser.actions();

  const widgetProps = {
    data: {
      idleStorageKey: 'seamless:idle-url',
    },
    events: {
      showIdleRecovery: () => {
        return window.location.hash === '#/' && user.uuid;
      },
      setIdleRecovery: () => {
        return window.location.hash !== '#/';
      },
      onIdleTick: () => {
        validateUser(
          () => null,
          (e) => {
            if (e.status === 401) {
              handleLogout();
            }
          }
        );
      },
      onSignout: () => {
        handleLogout();
      },
    },
  };

  return <IdleUser {...widgetProps} />;
};
